<template>
  <!-- <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
    <FormItem prop="userName">
      <i-input v-model="form.userName" name="company" placeholder="请输入用户名" autocomplete="on">
        <span slot="prepend">
          <Icon :size="16" type="ios-person"></Icon>
        </span>
      </i-input>
    </FormItem>
    <FormItem prop="password">
      <i-input type="password" v-model="form.password" placeholder="请输入密码">
        <span slot="prepend">
          <Icon :size="14" type="md-lock"></Icon>
        </span>
      </i-input>
    </FormItem>
    <FormItem>
      <Button @click="handleSubmit" type="primary" long>登录</Button>
    </FormItem>
  </Form> -->
  <div @keydown.enter.native="handleSubmit">
    <div class="newDiv">
      <i-input class="Special" v-model="userName" name="companyEpark" placeholder="请输入用户名" autocomplete="on" @on-blur="outUserNamet">
        <span slot="prepend">
          <Icon :size="16" type="ios-person"></Icon>
        </span>
      </i-input>
      <p class="ivu-form-item-error-tip" v-show="lengthNull">账号不能为空</p>
    </div>
    <div class="newDiv">
      <i-input class="SpecialPassword" type="password" v-model="password" placeholder="请输入密码" @on-blur="outPassword">
        <span slot="prepend">
          <Icon :size="14" type="md-lock"></Icon>
        </span>
      </i-input>
      <p class="ivu-form-item-error-tip" v-show="lengthNullPassword">密码不能为空</p>
    </div>
    <div class="newDiv">
      <Button @click="handleSubmit" type="primary" long>登录</Button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoginForm',
  // props: {
  //   userNameRules: {
  //     type: Array,
  //     default: () => {
  //       return [
  //         { required: true, message: '账号不能为空', trigger: 'blur' }
  //       ]
  //     }
  //   },
  //   passwordRules: {
  //     type: Array,
  //     default: () => {
  //       return [
  //         { required: true, message: '密码不能为空', trigger: 'blur' }
  //       ]
  //     }
  //   }
  // },
  data () {
    return {
      form: {
        userName: '',
        password: ''
      },
      userName: '',
      password: '',
      lengthNull: false,
      lengthNullPassword: false
    }
  },
  // computed: {
  //   rules () {
  //     return {
  //       userName: this.userNameRules,
  //       password: this.passwordRules
  //     }
  //   }
  // },
  created () {
    let that = this;
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key === 13) {
        that.handleSubmit();
      }
    }
  },
  watch: {
    'userName': function (newVal, oldVal) {
      this.outUserNamet();
    },
    'password': function (newVal, oldVal) {
      this.outPassword();
    }
  },
  methods: {
    outUserNamet () {
      var Special = document.getElementsByClassName('Special')[0];
      var ivuInput = document.getElementsByClassName('ivu-input')[0];
      if (this.userName === '') {
        Special.style.border = '1px solid red';
        Special.style.borderRadius = '4px';
        ivuInput.style.borderLeft = '1px solid red';
        this.lengthNull = true;
      } else {
        Special.style.border = 'none';
        Special.style.borderRadius = '4px';
        ivuInput.style.borderLeft = '1px solid #dcdee2';
        this.lengthNull = false;
      }
    },
    outPassword () {
      var SpecialPassword = document.getElementsByClassName('SpecialPassword')[0];
      var ivuInput = document.getElementsByClassName('ivu-input')[1];
      if (this.password === '') {
        SpecialPassword.style.border = '1px solid red';
        SpecialPassword.style.borderRadius = '4px';
        ivuInput.style.borderLeft = '1px solid red';
        this.lengthNullPassword = true;
      } else {
        SpecialPassword.style.border = 'none';
        SpecialPassword.style.borderRadius = '4px';
        ivuInput.style.borderLeft = '1px solid #dcdee2';
        this.lengthNullPassword = false;
      }
    },
    handleSubmit () {
      if (this.userName === '' || this.password === '' || this.lengthNull === true || this.lengthNullPassword === true) {
        this.outUserNamet();
        this.outPassword();
      } else {
        this.$emit('on-success-valid', {
          userName: this.userName,
          password: this.password,
          type: '1', // 登陆类型 用户名密码登陆:1，手机号,验证码登陆:2，
          platform: '2'
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.newDiv{
  margin-bottom: 24px;
  position: relative;
}
.ivu-form-item-error-tip{
  position: absolute;
  top: 100%;
  left: 0;
  line-height: 1;
  padding-top: 6px;
  color: #ed4014;
  font-size: 12px;
}
</style>
